import type { ID } from '@octopus-do/octopus-project-core'
import { SeoActions } from '@store/reducers/seo/actions'
import { ErrorNotification } from '@storeOld/reducers/notification'
import { call, put } from 'redux-saga/effects'

import type { Ga4Actions } from '../actions'
import type { Ga4CallbackFailure } from '../types'
import { fetchReport } from './fetchReport'
import { waitForProjectId } from './waitForProject'

// Молчаливый возврат с консента неотличим от «ничего не произошло»: адрес
// чистится, режим прежний, кнопка та же. Поэтому каждый неудачный исход
// получает текст.
const MESSAGE: Record<Ga4CallbackFailure, string> = {
  denied: 'Google Analytics is not connected: access was not granted.',
  expired:
    'Google Analytics is not connected: the connection link expired. Try again.',
  error: 'Google Analytics is not connected. Try again.',
}

export function* callbackFailed({
  payload,
}: ReturnType<typeof Ga4Actions.callbackFailed>) {
  // Как и на успешном пути — режим сразу, чтобы юзер не увидел карту сайта.
  yield put(SeoActions.enableMode())

  // Тост ждёт проект: пока идёт полноэкранный лоадер, показывать его некуда.
  const projectId: ID | null = yield call(waitForProjectId)

  yield put(ErrorNotification(MESSAGE[payload]))

  if (projectId === null) {
    return
  }

  // Обязательно, а не для порядка: режим включён до загрузки проекта, watcher
  // на changeMode отработал вхолостую, и статус так и остался idle — то есть
  // кнопка висела бы в лоадере до ручного выхода-входа в SEO-режим.
  yield call(fetchReport)
}
